import { ChevronRight } from "lucide-react";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";

import { cn } from "@/utils/cn";

interface ProfileMenuLinkRowProps {
  to?: string;
  icon: ReactNode;
  disabled?: boolean;
  title?: string;
  children: ReactNode;
}

export const ProfileMenuLinkRow = ({
  to,
  icon,
  disabled,
  title,
  children,
}: ProfileMenuLinkRowProps) => {
  const className = cn(
    "flex w-full items-center justify-between rounded-2xl border border-zinc-200 bg-white px-4 py-4 text-left no-underline transition",
    disabled ? "cursor-not-allowed opacity-60" : "hover:bg-zinc-50",
  );

  const inner = (
    <>
      <span
        className={cn(
          "flex items-center gap-3 font-medium",
          disabled ? "text-zinc-400" : "text-zinc-900",
        )}
      >
        <span className={cn(disabled ? "text-zinc-300" : "text-primary")}>{icon}</span>
        {children}
      </span>
      <ChevronRight className="h-5 w-5 text-zinc-400" />
    </>
  );

  if (disabled || !to) {
    return (
      <div className={className} title={title} aria-disabled={disabled}>
        {inner}
      </div>
    );
  }

  return (
    <Link to={to} className={className}>
      {inner}
    </Link>
  );
};
